import router from '@/router'
// eslint-disable-next-line object-curly-newline
import { reactive, getCurrentInstance, watch, toRefs } from '@vue/composition-api'
import { VueMaskFilter } from 'v-mask'
import { format, parse } from 'date-fns'
import { porExtenso, estilo } from 'numero-por-extenso'
import ptBR from 'date-fns/locale/pt-BR'

export const isObject = obj => typeof obj === 'object' && obj !== null

export const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)]

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const isDynamicRouteActive = route => {
  const { route: resolvedRoute } = router.resolve(route)
  return resolvedRoute.path === router.currentRoute.path
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy
  const state = reactive({
    route: vm.$route,
  })

  watch(
    () => vm.$route,
    r => {
      state.route = r
    },
  )

  return { ...toRefs(state), router: vm.$router }
}

export const truncateString = (str, num) => {
  if (!str) return ''
  if (str.length <= num) {
    return str
  }
  return `${str.slice(0, num)}...`
}

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }

export const formatCurrency = val => val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
export const formatCurrencyInt = val => (val ? formatCurrency(val / 100) : formatCurrency(val / 100))

export const formatCnpj = cnpj => VueMaskFilter(cnpj, '##.###.###/####-##')
export const formatCpf = (cpf, anonymize = false) => {
  if (anonymize && cpf) return cpf.replace(/(\d{6})(\d{3})(\d{2})/, '***.***.$2-$3')
  return VueMaskFilter(cpf, '###.###.###-##')
}
export const formatPhone = phone => VueMaskFilter(phone, '(##) #####-####')
export const formatDate = date => format(date, 'dd/MM/yyyy')

export const numberAsText = value => porExtenso(value, estilo.monetario)
export const onlyNumbers = value => value.replace(/\D/g, '')
export const roundUpper = value => Math.ceil(value)

export const formatDateTimeDDMMYYYY = date => {
  if (!date) return ''
  if (typeof date === 'string') {
    return format(parse(date, 'yyyy-MM-dd', new Date(), { locale: ptBR }), 'dd/MM/yyyy')
  }
  return format(date, 'dd/MM/yyyy')
}

export const formatDateTimeDDMMYYHHMM = date => {
  if (!date) return ''
  if (typeof date === 'string') {
    return format(parse(date, 'yyyy-MM-dd HH:mm:ss', new Date(), { locale: ptBR }), 'dd/MM/yy HH:mm', { locale: ptBR })
  }
  return format(date, 'dd/MM/yy HH:mm', { locale: ptBR })
}

export const parseDateForce = date => {
  if (/T/.test(date)) return new Date(date)
  return parse(date, 'dd/MM/yyyy HH:mm', new Date())
}

export const downloadFile = (filename, text) => {
  const element = document.createElement('a')
  element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`)
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
